import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLoading } from '../../context/loadingProvider';


const RouteTracker: React.FC = () => {
  const location = useLocation();
  const { markRouteAsVisited } = useLoading();

  useEffect(() => {
    markRouteAsVisited(location.pathname);
  }, [location.pathname, markRouteAsVisited]);

  return null;
};

export default RouteTracker; 